// @flow
import moment from 'moment';

export const getMeridian = (
  daySeconds: number,
): string => {
  if ((daySeconds % 86400) >= 43200) {
    return 'PM';
  }

  return 'AM';
};

export const getMeridianDateTime = (
  date: string,
): string => {
  return moment(date, 'ddd YYYY-MM-DD, hh:mm:ss:SSS').format('A');
};

export const transformUTCTimeToLocalTime = (daySeconds: number): number => {
  const result = daySeconds - new Date().getTimezoneOffset() * 60;
  return result > 0 ? result : 86400 + result;
};

export const transformTime = (daySeconds: number, format: number = 12): string => {
  let appereanceTime = daySeconds;
  if (format === 12) {
    appereanceTime = daySeconds % 43200;
  }

  const hours = Math.floor(appereanceTime / 3600);
  const minutes = Math.floor((appereanceTime % 3600) / 60);
  return `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`;
};

export const getDateDaySeconds = (date: Date) => (
  date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds()
);

export const transformDateStringToDaySeconds = (dateString: string): number => (
  getDateDaySeconds(new Date(dateString))
);



// WEBPACK FOOTER //
// ./src/scripts/lib/time.js